import { __extends } from "tslib";
import { Backend } from './base';
var SwanBackend = /** @class */ (function (_super) {
    __extends(SwanBackend, _super);
    function SwanBackend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sdk = swan;
        return _this;
    }
    SwanBackend.prototype.normalizeEnvInfo = function (systemInfo, networkStatus) {
        return {
            host_platform: 'swan',
            host_app_name: systemInfo.host,
            host_app_version: systemInfo.version,
            platform: systemInfo.platform,
            sdk_version: systemInfo.SDKVersion,
            os_name: systemInfo.platform,
            os_version: systemInfo.system,
            device_brand: systemInfo.brand,
            device_model: systemInfo.model,
            screen_width: systemInfo.screenWidth,
            screen_height: systemInfo.screenHeight,
            resolution: systemInfo.screenWidth + 'x' + systemInfo.screenHeight,
            pixel_ratio: systemInfo.pixelRatio,
            network_type: networkStatus.networkType,
        };
    };
    return SwanBackend;
}(Backend));
export default SwanBackend;
//# sourceMappingURL=swan.js.map